const VND_FORMATTER = new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 });

export function formatVND(amount: number | null | undefined): string {
  if (amount == null) return '—';
  return VND_FORMATTER.format(amount);
}

export function formatVNDShort(amount: number | null | undefined): string {
  if (amount == null) return '—';
  if (amount >= 1e9) return `${(amount / 1e9).toFixed(1)} tỷ`;
  if (amount >= 1e6) return `${(amount / 1e6).toFixed(0)}M`;
  if (amount >= 1e3) return `${(amount / 1e3).toFixed(0)}K`;
  return String(amount);
}

export function formatPercent(pct: number | null | undefined, digits = 1): string {
  if (pct == null) return '—';
  return `${pct.toFixed(digits)}%`;
}

export function formatNumber(n: number | null | undefined): string {
  if (n == null) return '—';
  return n.toLocaleString('vi-VN');
}
